import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61ad6bdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_5 = { class: "fs_18 fw_700 mb-4" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = ["onUpdate:modelValue", "disabled"]
const _hoisted_9 = ["onUpdate:modelValue", "disabled"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "ps-5 mt-2" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = ["onUpdate:modelValue", "disabled"]
const _hoisted_15 = ["onUpdate:modelValue", "disabled"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "d-flex justify-content-end mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Custom composition",
        text: "Custom composition",
        class: "mb-0"
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: _normalizeClass(["me-3 fw_700", _ctx.totalOk ? 'text-success' : 'text-danger'])
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Total",
            text: "Total",
            class: "me-1"
          }),
          _createTextVNode(_toDisplayString(_ctx.macroTotal.toFixed(2)) + "% ", 1)
        ], 2),
        _createElementVNode("span", {
          class: _normalizeClass(["me-3 fw_700", _ctx.childrenTotalOk ? 'text-success' : 'text-danger'])
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Sub-elements total",
            text: "Sub-elements total",
            class: "me-1"
          }),
          _createTextVNode(_toDisplayString(_ctx.childrenTotal.toFixed(2)) + "% ", 1)
        ], 2),
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-secondary me-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.load(true)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Reload Edmond preset",
                text: "Reload Edmond preset"
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-primary",
              disabled: !_ctx.isValid,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save()))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Save",
                text: "Save"
              })
            ], 8, _hoisted_3))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.subType), 1),
          (_ctx.globalErrors.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.globalErrors, (message, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(message), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compositions, (macro, macroIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "macroBlock mb-4",
              key: macroIndex
            }, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control me-2", { 'is-invalid': _ctx.isNameInvalid(macro.name) }]),
                  "onUpdate:modelValue": ($event: any) => ((macro.name) = $event),
                  disabled: _ctx.isReadOnly
                }, null, 10, _hoisted_8), [
                  [_vModelText, macro.name]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.01",
                  class: "form-control me-2",
                  style: {"max-width":"130px"},
                  "onUpdate:modelValue": ($event: any) => ((macro.percentage) = $event),
                  disabled: _ctx.isReadOnly
                }, null, 8, _hoisted_9), [
                  [
                    _vModelText,
                    macro.percentage,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["me-2 text-nowrap fs_14", _ctx.childrenOk(macro) ? 'text-success' : 'text-danger'])
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "children",
                    text: "children",
                    class: "me-1"
                  }),
                  _createTextVNode(_toDisplayString(_ctx.childrenSum(macro).toFixed(2)) + "% ", 1)
                ], 2),
                (!_ctx.isReadOnly)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-secondary btn-sm me-2 text-nowrap",
                      onClick: ($event: any) => (_ctx.addChild(macro))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Add element",
                        text: "Add element"
                      })
                    ], 8, _hoisted_10))
                  : _createCommentVNode("", true),
                (!_ctx.isReadOnly)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-danger btn-sm",
                      onClick: ($event: any) => (_ctx.removeMacro(macroIndex))
                    }, "x", 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rowErrors(macro.name), (message, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "text-danger fs_14 mt-1",
                  key: i
                }, _toDisplayString(message), 1))
              }), 128)),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(macro.insideComposition, (child, childIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb-2",
                    key: childIndex
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control me-2", { 'is-invalid': _ctx.isNameInvalid(child.name) }]),
                        "onUpdate:modelValue": ($event: any) => ((child.name) = $event),
                        disabled: _ctx.isReadOnly
                      }, null, 10, _hoisted_14), [
                        [_vModelText, child.name]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        step: "0.01",
                        class: "form-control me-2",
                        style: {"max-width":"130px"},
                        "onUpdate:modelValue": ($event: any) => ((child.percentage) = $event),
                        disabled: _ctx.isReadOnly
                      }, null, 8, _hoisted_15), [
                        [
                          _vModelText,
                          child.percentage,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      (!_ctx.isReadOnly)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-danger btn-sm",
                            onClick: ($event: any) => (_ctx.removeChild(macro, childIndex))
                          }, "x", 8, _hoisted_16))
                        : _createCommentVNode("", true)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rowErrors(child.name), (message, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "text-danger fs_14 mt-1",
                        key: i
                      }, _toDisplayString(message), 1))
                    }), 128))
                  ]))
                }), 128))
              ])
            ]))
          }), 128)),
          (!_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-secondary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addMacro()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Add macro-category",
                  text: "Add macro-category"
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/my-compositions')))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Cancel",
                text: "Cancel"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}